export default __webpack_public_path__ + "static/media/270px-165px-square-PMR-Dev-no-border.86ab0e97.jpg";